import ReactDom from 'react-dom';
import React, { useState, useEffect } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import DocViewer, { DocViewerRenderers } from "@cyntler/react-doc-viewer";
import "@cyntler/react-doc-viewer/dist/index.css"; // Import the necessary CSS
import '../css/VideoDialog.css';
import { useAuth } from './auth/AuthContext';
import DocMimeTypes from '../services/DocMimeTypes'; 

function DocumentDisplayModal(props) {
    const [docs, setDocs] = useState([]);
    const { secureFetch, getAccessToken } = useAuth();

    useEffect(() => {
        if (props.isOpen && props.fileId) {
            onLoad();
        }
    }, [props.isOpen]);

    async function onLoad() {
        let response = await secureFetch('api/mediaplayer/video/' + props.fileId);
        const blob = await response.blob();

        // 3. Create a local URL pointing to that blob
        const blobUrl = URL.createObjectURL(blob);


        let currentFileName = props.fileName;
        let fileExtn = currentFileName.substring(currentFileName.lastIndexOf('.') + 1)
        let curMimeType = DocMimeTypes[fileExtn.toLowerCase()] || 'application/octet-stream';

        //setVideoUrl(`${process.env.REACT_APP_API_BASE}/api/mediaplayer/video/${props.fileId}`);
        if (props.fileId) {
            const accessToken = getAccessToken();
            setDocs([
                {
                    uri: blobUrl,
                    fileName: props.fileName,
                    fileType: curMimeType,
                    requestHeaders: {
                        Authorization: `Bearer ${accessToken}`
                    }
                }
            ]);
        }
    }

    function getFileNameFromResponse(response) {
        const contentDisposition = response.headers.get('Content-Disposition');

        // 2. Parse the filename using regex or split
        let filename = "Your honor.mp4";
        if (contentDisposition) {
            const filenameMatch = contentDisposition.match(/filename="?([^";]+)"?/);
            if (filenameMatch.length > 1) {
                filename = filenameMatch[1];
            }
        }
        return filename;
    }

    // Don't forget to cleanup the memory when the component unmounts
    //useEffect(() => {
    //    return () => {
    //        if (videoUrl) URL.revokeObjectURL(videoUrl);
    //    };
    //}, [videoUrl]);

    function okClicked() {
        props.toggle();
        if (props.onOk)
            props.onOk();
    }
    function cancelClicked() {
        props.toggle();
        if (props.onCancel)
            props.onCancel();
    }

    return ReactDom.createPortal(
        <>
            <Modal size="lg" {...props} className={`video-modal ${props.loading}`} >
                <ModalHeader toggle={props.toggle}>Document Viewer</ModalHeader>
                <ModalBody>
                    <div>
                        {!docs.length && (<p>Loading file...</p>)}
                        <DocViewer
                            documents={docs} 
                            pluginRenderers={DocViewerRenderers}
                            /*config={{
                                header: {
                                    disableFileName: false,
                                    overrideComponent: ({ document, allDocuments, state, previousDocument, nextDocument }) => {
                                        // Your custom header logic here
                                        return <div>{fileName}</div>;
                                    },
                                }
                            }}*/
                        />

                    </div>

                </ModalBody>
                <ModalFooter>
                    <Button color="primary" onClick={okClicked}>
                        Ok
                    </Button>{' '}
                    <Button color="secondary" onClick={cancelClicked}>
                        Cancel
                    </Button>
                </ModalFooter>
                {props.loading && <div class='overlay'></div>}
            </Modal>
        </>
    , document.getElementById('portal'));

}

export default DocumentDisplayModal;
